export enum StorageTipo {
  LocalStorage = 'localstorage',
  SessionStorage = 'sessionstorage'
}
